<template>
    <div>
        <!-- <b-button @click="processPayment">Process Payment</b-button> -->

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <AffiliateBanner></AffiliateBanner>
        <!-- <template v-if="referral == 'HeyDominik'">
            <div class="alert alert-custom alert-white gutter-b" role="alert">
                <div class="alert-icon">
                    <i class="fas fa-check-circle text-warning"></i>
                </div>
                <div class="alert-text">
                    <h4 class="text-warning">Referral Bonus</h4>
                    <p>
                        You signed up using HeyDominik's referral code. As a thank you, you'll get
                        double the amount of Hashtag Performance Campaigns!
                    </p>
                </div>
            </div>
        </template>

        <template v-if="referral == 'MajedPhotos'">
            <div class="alert alert-custom alert-white gutter-b" role="alert">
                <div class="alert-icon">
                    <i class="fas fa-check-circle text-warning"></i>
                </div>
                <div class="alert-text">
                    <h4 class="text-warning">Referral Bonus</h4>
                    <p>
                        Thank you for registering using Majed Photo’s affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">
                            <template v-if="checkIs2021()"> $10 discount </template>
                            <template v-else> 10€ discount </template>
                        </span>
                        (on top of the normal discount!) on the 6-month and 12-month packages!
                    </p>
                </div>
            </div>
        </template>

        <template v-if="referral == 'ValentinDimitrov'">
            <div class="alert alert-custom alert-white gutter-b" role="alert">
                <div class="alert-icon">
                    <i class="fas fa-check-circle text-warning"></i>
                </div>
                <div class="alert-text">
                    <h4 class="text-warning">Referral Bonus</h4>
                    <p>
                        Thank you for registering using Valentin Dimitrov’s affiliate link, enjoy an
                        additional
                        <span class="font-weight-bolder">
                            <template v-if="checkIs2021()"> $10 discount </template>
                            <template v-else> 10€ discount </template>
                        </span>
                        (on top of the normal discount!) on the 6-month and 12-month packages!
                    </p>
                </div>
            </div>
        </template>

        <template v-if="referral == 'JordHammond'">
            <div class="alert alert-custom alert-white gutter-b" role="alert">
                <div class="alert-icon">
                    <i class="fas fa-check-circle text-warning"></i>
                </div>
                <div class="alert-text">
                    <h4 class="text-warning">Referral Bonus</h4>
                    <p>
                        Thank you for registering using Jord Hammond’s affiliate link, enjoy an
                        additional <span class="font-weight-bolder">20% discount</span> on all
                        Hashtastic packages!
                    </p>
                </div>
            </div>
        </template>

        <template v-if="referral == 'MonicaJ'">
            <div class="alert alert-custom alert-white gutter-b" role="alert">
                <div class="alert-icon">
                    <i class="fas fa-check-circle text-warning"></i>
                </div>
                <div class="alert-text">
                    <h4 class="text-warning">Referral Bonus</h4>
                    <p>
                        Thank you for registering using MonicaJ’s affiliate link, enjoy an
                        additional <span class="font-weight-bolder">20% discount</span> on all
                        Hashtastic packages!
                    </p>
                </div>
            </div>
        </template>

        <template v-if="referral == 'JavierSomoza'">
            <div class="alert alert-custom alert-white gutter-b" role="alert">
                <div class="alert-icon">
                    <i class="fas fa-check-circle text-warning"></i>
                </div>
                <div class="alert-text">
                    <h4 class="text-warning">Referral Bonus</h4>
                    <p>
                        Thank you for registering using Javier Somoza's affiliate link, enjoy an
                        additional <span class="font-weight-bolder">20% discount</span> on all
                        Hashtastic packages!
                    </p>
                </div>
            </div>
        </template> -->

        <template v-if="pageIsLoaded">
            <div class="card">
                <!-- begin: custom background-->
                <div
                    class="position-absolute w-100 h-50 rounded-card-top"
                    style="background-color: #22b9ff; max-height: 500px"
                ></div>
                <!-- end: custom background-->

                <div class="card-body position-relative">
                    <h1 class="text-white text-center mt-10">
                        Enjoy Unlimited Access to ALL of Hashtastic's features
                    </h1>
                    <h5 class="7 text-white text-center mb-15">
                        Stop wasting time trying to find hashtags that kind of work, and let
                        Hashtastic do the math for you. Every time.
                    </h5>

                    <!-- begin: Tabs-->
                    <div class="d-flex justify-content-center">
                        <ul
                            class="nav nav-pills nav-primary mb-10 mb-lg-20 bg-white rounded"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li class="nav-item p-0 m-0">
                                <button
                                    class="nav-link font-weight-bolder rounded-right-0 px-8 py-5"
                                    :class="activePanel == 'panel1' ? 'active' : ''"
                                    id="pills-tab-1"
                                    @click="selectPanel('panel1')"
                                >
                                    Personal Plans
                                </button>
                            </li>
                            <li class="nav-item p-0 m-0">
                                <button
                                    class="nav-link font-weight-bolder rounded-left-0 px-8 py-5"
                                    :class="activePanel == 'panel2' ? 'active' : ''"
                                    id="pills-tab-2"
                                    @click="selectPanel('panel2')"
                                >
                                    Enterprise Plans
                                </button>
                            </li>
                            <!-- <li class="nav-item p-0 m-0">
                                <button
                                    class="nav-link font-weight-bolder rounded-left-0 px-8 py-5"
                                    :class="(activePanel == 'panel3' ? 'active' : '')"
                                    id="pills-tab-2"
                                    @click="selectPanel('panel3')"
                                >
                                    Upgrade
                                </button>
                            </li> -->
                        </ul>
                    </div>
                    <!-- end: Tabs-->

                    <div class="tab-content">
                        <!-- SECTION - PERSONAL PLANS -->
                        <!-- begin: Tab pane-->
                        <div
                            class="tab-pane show row text-center"
                            id="kt-pricing-2_content1"
                            role="tabpanel"
                            aria-labelledby="pills-tab-1"
                            ref="panel1"
                            :class="activePanel == 'panel1' ? 'active' : ''"
                        >
                            <div
                                class="card-body bg-white col-11 col-lg-12 col-xxl-10 mx-auto shadow-sm"
                            >
                                <div class="row">
                                    <!-- begin: Pricing-->
                                    <div class="col-md-4">
                                        <div class="pt-30 pt-md-25 pb-15 px-5 text-center">
                                            <!--begin::Icon-->
                                            <div class="d-flex flex-center position-relative mb-25">
                                                <span
                                                    class="svg svg-fill-primary opacity-4 position-absolute"
                                                >
                                                    <svg width="175" height="200">
                                                        <polyline
                                                            points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"
                                                        ></polyline>
                                                    </svg>
                                                </span>
                                                <span class="svg-icon svg-icon-5x svg-icon-primary">
                                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Home/Flower3.svg-->
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            stroke-width="1"
                                                            fill="none"
                                                            fill-rule="evenodd"
                                                        >
                                                            <polygon
                                                                points="0 0 24 0 24 24 0 24"
                                                            ></polygon>
                                                            <path
                                                                d="M1.4152146,4.84010415 C11.1782334,10.3362599 14.7076452,16.4493804 12.0034499,23.1794656 C5.02500006,22.0396582 1.4955883,15.9265377 1.4152146,4.84010415 Z"
                                                                fill="#000000"
                                                                opacity="0.3"
                                                            ></path>
                                                            <path
                                                                d="M22.5950046,4.84010415 C12.8319858,10.3362599 9.30257403,16.4493804 12.0067693,23.1794656 C18.9852192,22.0396582 22.5146309,15.9265377 22.5950046,4.84010415 Z"
                                                                fill="#000000"
                                                                opacity="0.3"
                                                            ></path>
                                                            <path
                                                                d="M12.0002081,2 C6.29326368,11.6413199 6.29326368,18.7001435 12.0002081,23.1764706 C17.4738192,18.7001435 17.4738192,11.6413199 12.0002081,2 Z"
                                                                fill="#000000"
                                                                opacity="0.3"
                                                            ></path>
                                                        </g></svg
                                                    ><!--end::Svg Icon-->
                                                </span>
                                            </div>
                                            <!--end::Icon-->

                                            <!--begin::Content-->
                                            <h4 class="font-size-h3 mb-10">Basic Plan</h4>
                                            <div class="d-flex flex-column line-height-xl pb-10">
                                                <span>30 Days</span>
                                                <span>
                                                    <!-- <b-badge
                                                        class="mr-1"
                                                        variant="primary"
                                                        @click="handleBaseSubscriptionCounter(-1)"
                                                        >-</b-badge
                                                    > -->
                                                    {{ baseSubscriptionCampaignCount * multiplier }}
                                                    <!-- <b-badge
                                                        class="mr-1"
                                                        variant="primary"
                                                        @click="handleBaseSubscriptionCounter(+1)"
                                                        >+</b-badge
                                                    > -->
                                                    Account(s) with Hashtag Performance Campaigns
                                                    <HashtagPerformanceTooltip
                                                        id="perf1"
                                                    ></HashtagPerformanceTooltip>
                                                </span>
                                                <span>Unlimited access</span>
                                                <span>Unlimited searches</span>
                                                <span>Unlimited accounts</span>
                                                <span>Unlimited viral media</span>
                                                <span class="text-white font-weight-bolder">.</span>
                                            </div>
                                            <template v-if="checkIs2021()">
                                                <span class="d-block display-3 font-weight-bold">
                                                    {{ enterpriseplans[basicPlans.one].price
                                                    }}<sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >€</sup
                                                    >
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="d-block display-3 font-weight-bold">
                                                    <sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >$</sup
                                                    >{{ enterpriseplans[basicPlans.one].price }}
                                                </span>
                                            </template>

                                            <span><sub>(Excl. VAT)</sub></span>
                                            <div class="mt-7">
                                                <a
                                                    @click="
                                                        getPaymentLink('stripe', basicPlans.one)
                                                    "
                                                    class="btn btn-primary text-uppercase font-weight-bolder px-15 py-3 col-12 mb-3"
                                                >
                                                    <i class="fab fa-cc-visa"></i>
                                                    Credit / Debit Card
                                                </a>
                                                <a
                                                    @click="
                                                        getPaymentLink('paypal', basicPlans.one)
                                                    "
                                                    class="btn btn-outline-primary text-uppercase font-weight-bolder px-15 py-3 col-12"
                                                >
                                                    <i class="fab fa-paypal"></i>
                                                    PayPal
                                                </a>
                                            </div>
                                            <!--end::Content-->
                                        </div>
                                    </div>
                                    <!-- end: Pricing-->

                                    <!-- begin: Pricing-->
                                    <div
                                        class="col-md-4 border-x-0 border-x-md border-y border-y-md-0"
                                    >
                                        <div class="pt-30 pt-md-25 pb-15 px-5 text-center">
                                            <!--begin::Icon-->
                                            <div class="d-flex flex-center position-relative mb-25">
                                                <span
                                                    class="svg svg-fill-primary opacity-4 position-absolute"
                                                >
                                                    <svg width="175" height="200">
                                                        <polyline
                                                            points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"
                                                        ></polyline>
                                                    </svg>
                                                </span>
                                                <span class="svg-icon svg-icon-5x svg-icon-success">
                                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Tools/Compass.svg-->
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            stroke-width="1"
                                                            fill="none"
                                                            fill-rule="evenodd"
                                                        >
                                                            <rect
                                                                x="0"
                                                                y="0"
                                                                width="24"
                                                                height="24"
                                                            ></rect>
                                                            <path
                                                                d="M7.07744993,12.3040451 C7.72444571,13.0716094 8.54044565,13.6920474 9.46808594,14.1079953 L5,23 L4.5,18 L7.07744993,12.3040451 Z M14.5865511,14.2597864 C15.5319561,13.9019016 16.375416,13.3366121 17.0614026,12.6194459 L19.5,18 L19,23 L14.5865511,14.2597864 Z M12,3.55271368e-14 C12.8284271,3.53749572e-14 13.5,0.671572875 13.5,1.5 L13.5,4 L10.5,4 L10.5,1.5 C10.5,0.671572875 11.1715729,3.56793164e-14 12,3.55271368e-14 Z"
                                                                fill="#000000"
                                                                opacity="0.3"
                                                            ></path>
                                                            <path
                                                                d="M12,10 C13.1045695,10 14,9.1045695 14,8 C14,6.8954305 13.1045695,6 12,6 C10.8954305,6 10,6.8954305 10,8 C10,9.1045695 10.8954305,10 12,10 Z M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z"
                                                                fill="#000000"
                                                                fill-rule="nonzero"
                                                            ></path>
                                                        </g></svg
                                                    ><!--end::Svg Icon-->
                                                </span>
                                            </div>
                                            <!--end::Icon-->

                                            <!--begin::Content-->
                                            <h4 class="font-size-h3 mb-10">Pro Plan</h4>
                                            <div class="d-flex flex-column line-height-xl mb-10">
                                                <span>180 days</span>
                                                <span>
                                                    {{ 2 * multiplier }} Accounts with Hashtag
                                                    Performance Campaigns
                                                    <HashtagPerformanceTooltip
                                                        id="perf2"
                                                    ></HashtagPerformanceTooltip>
                                                </span>
                                                <span>Unlimited access</span>
                                                <span>Unlimited searches</span>
                                                <span>Unlimited accounts</span>
                                                <span>Unlimited viral media</span>
                                                <span class="text-success font-weight-bolder"
                                                    >1 month free!</span
                                                >
                                            </div>
                                            <template v-if="checkIs2021()">
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >79.94€</s
                                                    >
                                                    {{ enterpriseplans[basicPlans.six].price
                                                    }}<sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >€</sup
                                                    ></span
                                                >
                                            </template>
                                            <template v-else>
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >$59.94</s
                                                    >
                                                    <sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >$</sup
                                                    >{{
                                                        enterpriseplans[basicPlans.six].price
                                                    }}</span
                                                >
                                            </template>

                                            <span><sub>(Excl. VAT)</sub></span>
                                            <div class="mt-7">
                                                <a
                                                    @click="
                                                        getPaymentLink('stripe', basicPlans.six)
                                                    "
                                                    class="btn btn-primary text-uppercase font-weight-bolder px-15 py-3 col-12 mb-3"
                                                >
                                                    <i class="fab fa-cc-visa"></i>
                                                    Credit / Debit Card
                                                </a>
                                                <a
                                                    @click="
                                                        getPaymentLink('paypal', basicPlans.six)
                                                    "
                                                    class="btn btn-outline-primary text-uppercase font-weight-bolder px-15 py-3 col-12"
                                                >
                                                    <i class="fab fa-paypal"></i>
                                                    PayPal
                                                </a>
                                            </div>
                                            <!--end::Content-->
                                        </div>
                                    </div>
                                    <!-- end: Pricing-->

                                    <!-- begin: Pricing-->
                                    <div class="col-md-4">
                                        <div class="pt-30 pt-md-25 pb-15 px-5 text-center">
                                            <!--begin::Icon-->
                                            <div class="d-flex flex-center position-relative mb-25">
                                                <span
                                                    class="svg svg-fill-primary opacity-4 position-absolute"
                                                >
                                                    <svg width="175" height="200">
                                                        <polyline
                                                            points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"
                                                        ></polyline>
                                                    </svg>
                                                </span>
                                                <span class="svg-icon svg-icon-5x svg-icon-primary">
                                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Shopping/Cart2.svg-->
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        width="24px"
                                                        height="24px"
                                                        viewBox="0 0 24 24"
                                                        version="1.1"
                                                    >
                                                        <g
                                                            stroke="none"
                                                            stroke-width="1"
                                                            fill="none"
                                                            fill-rule="evenodd"
                                                        >
                                                            <rect
                                                                x="0"
                                                                y="0"
                                                                width="24"
                                                                height="24"
                                                            ></rect>
                                                            <path
                                                                d="M12,4.56204994 L7.76822128,9.6401844 C7.4146572,10.0644613 6.7840925,10.1217854 6.3598156,9.76822128 C5.9355387,9.4146572 5.87821464,8.7840925 6.23177872,8.3598156 L11.2317787,2.3598156 C11.6315738,1.88006147 12.3684262,1.88006147 12.7682213,2.3598156 L17.7682213,8.3598156 C18.1217854,8.7840925 18.0644613,9.4146572 17.6401844,9.76822128 C17.2159075,10.1217854 16.5853428,10.0644613 16.2317787,9.6401844 L12,4.56204994 Z"
                                                                fill="#000000"
                                                                fill-rule="nonzero"
                                                                opacity="0.3"
                                                            ></path>
                                                            <path
                                                                d="M3.28077641,9 L20.7192236,9 C21.2715083,9 21.7192236,9.44771525 21.7192236,10 C21.7192236,10.0817618 21.7091962,10.163215 21.6893661,10.2425356 L19.5680983,18.7276069 C19.234223,20.0631079 18.0342737,21 16.6576708,21 L7.34232922,21 C5.96572629,21 4.76577697,20.0631079 4.43190172,18.7276069 L2.31063391,10.2425356 C2.17668518,9.70674072 2.50244587,9.16380623 3.03824078,9.0298575 C3.11756139,9.01002735 3.1990146,9 3.28077641,9 Z M12,12 C11.4477153,12 11,12.4477153 11,13 L11,17 C11,17.5522847 11.4477153,18 12,18 C12.5522847,18 13,17.5522847 13,17 L13,13 C13,12.4477153 12.5522847,12 12,12 Z M6.96472382,12.1362967 C6.43125772,12.2792385 6.11467523,12.8275755 6.25761704,13.3610416 L7.29289322,17.2247449 C7.43583503,17.758211 7.98417199,18.0747935 8.51763809,17.9318517 C9.05110419,17.7889098 9.36768668,17.2405729 9.22474487,16.7071068 L8.18946869,12.8434035 C8.04652688,12.3099374 7.49818992,11.9933549 6.96472382,12.1362967 Z M17.0352762,12.1362967 C16.5018101,11.9933549 15.9534731,12.3099374 15.8105313,12.8434035 L14.7752551,16.7071068 C14.6323133,17.2405729 14.9488958,17.7889098 15.4823619,17.9318517 C16.015828,18.0747935 16.564165,17.758211 16.7071068,17.2247449 L17.742383,13.3610416 C17.8853248,12.8275755 17.5687423,12.2792385 17.0352762,12.1362967 Z"
                                                                fill="#000000"
                                                            ></path>
                                                        </g></svg
                                                    ><!--end::Svg Icon-->
                                                </span>
                                            </div>
                                            <!--end::Icon-->

                                            <!--begin::Content-->
                                            <h4 class="font-size-h3 mb-10">Master Plan</h4>
                                            <div class="d-flex flex-column line-height-xl mb-10">
                                                <span>365 Days</span>
                                                <span>
                                                    {{ 3 * multiplier }} Accounts with Hashtag
                                                    Performance Campaigns
                                                    <HashtagPerformanceTooltip
                                                        id="perf3"
                                                    ></HashtagPerformanceTooltip>
                                                </span>
                                                <span>Unlimited access</span>
                                                <span>Unlimited searches</span>
                                                <span>Unlimited accounts</span>
                                                <span>Unlimited viral media</span>
                                                <span class="text-success font-weight-bolder"
                                                    >3 months free!</span
                                                >
                                            </div>
                                            <template v-if="checkIs2021()">
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >155.99€</s
                                                    >
                                                    {{ enterpriseplans[basicPlans.twelve].price
                                                    }}<sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >€</sup
                                                    >
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >$119.99</s
                                                    >
                                                    <sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >$</sup
                                                    >{{ enterpriseplans[basicPlans.twelve].price }}
                                                </span>
                                            </template>

                                            <span><sub>(Excl. VAT)</sub></span>
                                            <div class="mt-7">
                                                <a
                                                    @click="
                                                        getPaymentLink('stripe', basicPlans.twelve)
                                                    "
                                                    class="btn btn-primary text-uppercase font-weight-bolder px-15 py-3 col-12 mb-3"
                                                >
                                                    <i class="fab fa-cc-visa"></i>
                                                    Credit / Debit Card
                                                </a>
                                                <a
                                                    @click="
                                                        getPaymentLink('paypal', basicPlans.twelve)
                                                    "
                                                    class="btn btn-outline-primary text-uppercase font-weight-bolder px-15 py-3 col-12"
                                                >
                                                    <i class="fab fa-paypal"></i>
                                                    PayPal
                                                </a>
                                            </div>
                                            <!--end::Content-->
                                        </div>
                                    </div>
                                    <!-- end: Pricing-->
                                </div>
                            </div>
                        </div>
                        <!-- end: Tab pane-->

                        <!-- SECTION - ENTERPRISE PLANS -->
                        <!-- begin: Tab pane-->
                        <div
                            class="tab-pane row text-center"
                            id="kt-pricing-2_content2"
                            role="tabpanel"
                            aria-labelledby="pills-tab-2"
                            ref="panel2"
                            :class="activePanel == 'panel2' ? 'active' : ''"
                        >
                            <div
                                class="card card-body bg-white col-11 col-lg-12 col-xxl-10 mx-auto gutter-b shadow-sm"
                            >
                                <div
                                    class="alert alert-custom alert-white shadow-sm text-left gutter-b"
                                    role="alert"
                                    v-if="hasMultiplier"
                                >
                                    <div class="alert-icon">
                                        <i class="fas fa-check-circle text-success"></i>
                                    </div>
                                    <div class="alert-text">
                                        <p>
                                            You can use the dropdown below to customise your package
                                            with your required number of Hashtag Performance
                                            Campaigns, i.e. how many Instagram accounts you would
                                            like Hashtastic to continuously analyse for post
                                            performance data!
                                        </p>
                                        <p>The more Campaigns you order, the cheaper it gets!</p>
                                    </div>
                                </div>

                                <b-form-group
                                    label-cols="4"
                                    label-cols-lg="2"
                                    label="Number of Campaigns"
                                    class="mb-0"
                                >
                                    <b-form-select
                                        v-model="enterpriseselectedcampaigns"
                                        :options="enterpriseOptions"
                                    ></b-form-select>
                                </b-form-group>
                            </div>

                            <div
                                class="card-body bg-white col-11 col-lg-12 col-xxl-10 mx-auto shadow-sm"
                            >
                                <div class="row justify-content-center">
                                    <!-- begin: Pricing-->
                                    <div class="col-md-4">
                                        <div class="pt-30 pt-md-25 pb-15 px-5 text-center">
                                            <!--begin::Icon-->
                                            <div class="d-flex flex-center position-relative mb-25">
                                                <span
                                                    class="svg svg-fill-primary opacity-4 position-absolute"
                                                >
                                                    <svg width="175" height="200">
                                                        <polyline
                                                            points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"
                                                        ></polyline>
                                                    </svg>
                                                </span>
                                                <span class="svg-icon svg-icon-5x svg-icon-primary">
                                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Home/Flower3.svg-->
                                                    <i
                                                        class="fa flaticon2-architecture-and-city fa-5x text-primary"
                                                    ></i>
                                                </span>
                                            </div>
                                            <!--end::Icon-->

                                            <!--begin::Content-->
                                            <h4 class="font-size-h3 mb-10">Basic Plan</h4>
                                            <div class="d-flex flex-column line-height-xl pb-10">
                                                <span>30 Days</span>
                                                <span>
                                                    <i class="fas fa-fire-alt text-danger mr-2"></i>
                                                    {{ enterpriseOne.campaigns * multiplier }}
                                                    Accounts with Hashtag Performance Campaigns
                                                    <HashtagPerformanceTooltip
                                                        id="perf4"
                                                    ></HashtagPerformanceTooltip>
                                                </span>
                                                <span>Unlimited access</span>
                                                <span>Unlimited searches</span>
                                                <span>Unlimited accounts</span>
                                                <span>Unlimited viral media</span>
                                                <span class="text-warning font-weight-bolder"
                                                    >Export PDF reports for your Accounts</span
                                                >
                                                <span class="text-white font-weight-bolder">.</span>
                                            </div>
                                            <template v-if="checkIs2021()">
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >{{ enterpriseOne.strikedprice }}€</s
                                                    >
                                                    {{ enterpriseOne.price
                                                    }}<sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >€</sup
                                                    >
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >${{ enterpriseOne.strikedprice }}</s
                                                    >
                                                    <sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >$</sup
                                                    >{{ enterpriseOne.price }}
                                                </span>
                                            </template>

                                            <span><sub>(Excl. VAT)</sub></span>
                                            <div class="mt-7">
                                                <a
                                                    @click="
                                                        getPaymentLink(
                                                            'stripe',
                                                            enterpriseOne.links.stripe
                                                        )
                                                    "
                                                    class="btn btn-primary text-uppercase font-weight-bolder px-15 py-3 col-12 mb-3"
                                                >
                                                    <i class="fab fa-cc-visa"></i>
                                                    Credit / Debit Card
                                                </a>
                                                <a
                                                    @click="
                                                        getPaymentLink(
                                                            'paypal',
                                                            enterpriseOne.links.paypal
                                                        )
                                                    "
                                                    class="btn btn-outline-primary text-uppercase font-weight-bolder px-15 py-3 col-12"
                                                >
                                                    <i class="fab fa-paypal"></i>
                                                    PayPal
                                                </a>
                                            </div>
                                            <!--end::Icon-->
                                        </div>
                                    </div>
                                    <!-- end: Pricing-->

                                    <!-- begin: Pricing-->
                                    <div
                                        class="col-md-4 border-x-0 border-x-md border-y border-y-md-0"
                                    >
                                        <div class="pt-30 pt-md-25 pb-15 px-5 text-center">
                                            <!--begin::Icon-->
                                            <div class="d-flex flex-center position-relative mb-25">
                                                <span
                                                    class="svg svg-fill-primary opacity-4 position-absolute"
                                                >
                                                    <svg width="175" height="200">
                                                        <polyline
                                                            points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"
                                                        ></polyline>
                                                    </svg>
                                                </span>
                                                <span class="svg-icon svg-icon-5x svg-icon-primary">
                                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Tools/Compass.svg-->
                                                    <i
                                                        class="fa flaticon2-rocket-1 fa-5x text-success"
                                                    ></i>
                                                </span>
                                            </div>
                                            <!--end::Icon-->

                                            <!--begin::Content-->
                                            <h4 class="font-size-h3 mb-10">Pro Plan</h4>
                                            <div class="d-flex flex-column line-height-xl pb-10">
                                                <span>180 Days</span>
                                                <span>
                                                    <i class="fas fa-fire-alt text-danger mr-2"></i>
                                                    {{ enterpriseSix.campaigns * multiplier }}
                                                    Accounts with Hashtag Performance Campaigns
                                                    <HashtagPerformanceTooltip
                                                        id="perf5"
                                                    ></HashtagPerformanceTooltip>
                                                </span>
                                                <span>Unlimited access</span>
                                                <span>Unlimited searches</span>
                                                <span>Unlimited accounts</span>
                                                <span>Unlimited viral media</span>
                                                <span class="text-warning font-weight-bolder"
                                                    >Export PDF reports for your Accounts</span
                                                >
                                                <span class="text-success font-weight-bolder"
                                                    >1 month free</span
                                                >
                                            </div>
                                            <template v-if="checkIs2021()">
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >{{ enterpriseSix.strikedprice }}€</s
                                                    >
                                                    {{ enterpriseSix.price
                                                    }}<sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >€</sup
                                                    >
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >${{ enterpriseSix.strikedprice }}</s
                                                    >
                                                    <sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >$</sup
                                                    >{{ enterpriseSix.price }}
                                                </span>
                                            </template>
                                            <span><sub>(Excl. VAT)</sub></span>
                                            <div class="mt-7">
                                                <a
                                                    @click="
                                                        getPaymentLink(
                                                            'stripe',
                                                            enterpriseSix.links.stripe
                                                        )
                                                    "
                                                    class="btn btn-primary text-uppercase font-weight-bolder px-15 py-3 col-12 mb-3"
                                                >
                                                    <i class="fab fa-cc-visa"></i>
                                                    Credit / Debit Card
                                                </a>
                                                <a
                                                    @click="
                                                        getPaymentLink(
                                                            'paypal',
                                                            enterpriseSix.links.paypal
                                                        )
                                                    "
                                                    class="btn btn-outline-primary text-uppercase font-weight-bolder px-15 py-3 col-12"
                                                >
                                                    <i class="fab fa-paypal"></i>
                                                    PayPal
                                                </a>
                                            </div>
                                            <!--end::Content-->
                                        </div>
                                    </div>
                                    <!-- end: Pricing-->

                                    <!-- begin: Pricing-->
                                    <div class="col-md-4">
                                        <div class="pt-30 pt-md-25 pb-15 px-5 text-center">
                                            <!--begin::Icon-->
                                            <div class="d-flex flex-center position-relative mb-25">
                                                <span
                                                    class="svg svg-fill-primary opacity-4 position-absolute"
                                                >
                                                    <svg width="175" height="200">
                                                        <polyline
                                                            points="87,0 174,50 174,150 87,200 0,150 0,50 87,0"
                                                        ></polyline>
                                                    </svg>
                                                </span>
                                                <span class="svg-icon svg-icon-5x svg-icon-primary">
                                                    <!--begin::Svg Icon | path:/metronic/themes/metronic/theme/html/demo2/dist/assets/media/svg/icons/Shopping/Cart2.svg-->
                                                    <i
                                                        class="fa flaticon2-box fa-5x text-danger"
                                                    ></i>
                                                </span>
                                            </div>
                                            <!--end::Icon-->

                                            <!--end::Content-->
                                            <h4 class="font-size-h3 mb-10">Master Plan</h4>
                                            <div class="d-flex flex-column line-height-xl pb-10">
                                                <span>365 Days</span>
                                                <span>
                                                    <i class="fas fa-fire-alt text-danger mr-2"></i>
                                                    {{ enterpriseTwelve.campaigns * multiplier }}
                                                    Accounts with Hashtag Performance Campaigns
                                                    <HashtagPerformanceTooltip
                                                        id="perf6"
                                                    ></HashtagPerformanceTooltip>
                                                </span>
                                                <span>Unlimited access</span>
                                                <span>Unlimited searches</span>
                                                <span>Unlimited accounts</span>
                                                <span>Unlimited viral media</span>
                                                <span class="text-warning font-weight-bolder"
                                                    >Export PDF reports for your Accounts</span
                                                >
                                                <span class="text-success font-weight-bolder"
                                                    >3 months free!</span
                                                >
                                            </div>
                                            <template v-if="checkIs2021()">
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >{{ enterpriseTwelve.strikedprice }}€</s
                                                    >
                                                    {{ enterpriseTwelve.price
                                                    }}<sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >€</sup
                                                    >
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="d-block display-3 font-weight-bold">
                                                    <s
                                                        class="text-dark-50 font-size-h6 font-weight-normal"
                                                        >${{ enterpriseTwelve.strikedprice }}</s
                                                    >
                                                    <sup
                                                        class="font-size-h3 font-weight-normal pl-1"
                                                        >$</sup
                                                    >{{ enterpriseTwelve.price }}
                                                </span>
                                            </template>
                                            <span><sub>(Excl. VAT)</sub></span>
                                            <div class="mt-7">
                                                <a
                                                    @click="
                                                        getPaymentLink(
                                                            'stripe',
                                                            enterpriseTwelve.links.stripe
                                                        )
                                                    "
                                                    class="btn btn-primary text-uppercase font-weight-bolder px-15 py-3 col-12 mb-3"
                                                >
                                                    <i class="fab fa-cc-visa"></i>
                                                    Credit / Debit Card
                                                </a>
                                                <a
                                                    @click="
                                                        getPaymentLink(
                                                            'paypal',
                                                            enterpriseTwelve.links.paypal
                                                        )
                                                    "
                                                    class="btn btn-outline-primary text-uppercase font-weight-bolder px-15 py-3 col-12"
                                                >
                                                    <i class="fab fa-paypal"></i>
                                                    PayPal
                                                </a>
                                            </div>
                                            <!--end::Content-->
                                        </div>
                                    </div>
                                    <!-- end: Pricing-->
                                </div>
                            </div>

                            <div
                                class="card-body bg-white col-11 col-lg-12 col-xxl-10 mx-auto shadow-sm gutter-t"
                            >
                                If you would like a custom package with additional features, please
                                get in touch with
                                <span class="text-success font-weight-bolder"
                                    >support@hashtastic.eu</span
                                >
                                for a quote.
                            </div>
                        </div>
                        <!-- end: Tab pane-->
                    </div>
                </div>
            </div>
        </template>
        <stripe-checkout
            ref="checkoutRef"
            :pk="stripe.publishableKey"
            :sessionId="stripe.sessionId"
            class="d-none"
        >
        </stripe-checkout>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<script>
// Defaults
import { StripeCheckout } from "vue-stripe-checkout";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";
import is2021mixin from "@/mixins/is2021mixin";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import AffiliateBanner from "@/view/content/Custom/AffiliateBanner.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import HashtagPerformanceTooltip from "@/view/content/Custom/HashtagPerformanceTooltip.vue";
// Getters
import { mapGetters } from "vuex";
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

//    import ClipboardJS from "clipboard";
//    window.ClipboardJS = ClipboardJS;

export default {
    name: "SubscribePage",
    mixins: [axiosErrorManagement, is2021mixin],
    components: {
        PagePreloader,
        CustomAlerts,
        AffiliateBanner,
        HashtagPerformanceTooltip,
        StripeCheckout,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,

            // Panels
            activePanel: "panel1",

            // Errors
            errors: [],

            // Stripe manager
            stripe: {
                publishableKey: "pk_live_QF7wOSuJFc3eN5o0qeQWV8AJ00L02blD8g",
                // Sandbox - pk_test_ZcCOsfpeeeKfB49rvXVaupHQ00QgByLAQ2
                // Production - pk_live_QF7wOSuJFc3eN5o0qeQWV8AJ00L02blD8g
                sessionId: "",
            },

            // Plan modifiers
            baseSubscriptionCampaignCount: 1,
            multiplier: 1,
            hasMultiplier: false,

            // Referral displayers
            referral: "",

            // Default payment links
            paypalBase: "/Paypal.php?plan=",
            stripeBase: "/Stripe.php?plan=",

            // Enterprise Plans Modifiers
            enterpriseselectedcampaigns: 5,
            enterpriseOptions: [
                { value: 5, text: "5 Hashtag Performance Campaigns" },
                { value: 10, text: "10 Hashtag Performance Campaigns" },
                { value: 25, text: "25 Hashtag Performance Campaigns" },
                { value: 50, text: "50 Hashtag Performance Campaigns" },
                { value: 100, text: "100 Hashtag Performance Campaigns" },
            ],

            // Plans
            basicPlans: {
                one: 1,
                six: 2,
                twelve: 3,
            },
            enterpriseplans: {},
        };
    },

    methods: {
        processPayment() {
            this.$router.push({
                name: "dashboard",
                params: {
                    propFlashMessages: "payment_success_thanks",
                },
            });
        },

        selectPanel(panel) {
            this.activePanel = panel;
        },

        getPricePlans() {
            axios
                .get("subscribe/prices")
                .then((response) => {
                    this.enterpriseplans = response.data;
                    this.pageIsLoaded = true; // Putting this here so the page only displays if everything works
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Do nothing in case of error
                });
        },

        getEnterpriseDetails(prefix) {
            if (
                typeof this.enterpriseplans[prefix + this.enterpriseselectedcampaigns] ===
                "undefined"
            ) {
                return {
                    price: 1,
                    strikedprice: 1,
                    campaigns: 1,
                    links: {
                        paypal: 1,
                        stripe: 1,
                    },
                };
            } else {
                // Set base variables
                var campaigns =
                    this.enterpriseplans[prefix + this.enterpriseselectedcampaigns].campaigns;
                var price = this.enterpriseplans[prefix + this.enterpriseselectedcampaigns].price;
                var duration =
                    this.enterpriseplans[prefix + this.enterpriseselectedcampaigns].duration;

                // Calculate striked price
                if (duration > 1) {
                    // 6 or 12 months
                    // Do math
                    var baseprice =
                        this.enterpriseplans["101" + this.enterpriseselectedcampaigns].price;

                    // Do more math
                    var strikedprice = baseprice * duration;
                } else {
                    var baseprice = this.enterpriseplans["1"].price;
                    var strikedprice = baseprice * campaigns;
                }

                // Round result
                strikedprice = Math.round(strikedprice * 100) / 100;

                // Generate links
                var paypal = prefix + campaigns;
                var stripe = prefix + campaigns;

                // Return
                return {
                    price: price,
                    strikedprice: strikedprice,
                    campaigns: campaigns,
                    links: {
                        paypal: paypal,
                        stripe: stripe,
                    },
                };
            }
        },

        getPaymentLink(origin, sku, upgrade = false) {
            // Reset errors
            this.errors = [];

            // Set page loader
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

            // Perform request
            axios
                .post("subscribe/link", {
                    origin: origin,
                    sku: sku,
                    upgrade: upgrade,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        if (origin == "paypal") {
                            window.location.href = data.data;
                        } else {
                            this.stripe.sessionId = data.data;
                            this.$refs.checkoutRef.redirectToCheckout();
                        }
                        // Redirect to URL
                    } else {
                        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    }

                    // Do error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((currentItem) => {
                            this.errors.push({
                                type: currentItem.type,
                                message: currentItem.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                });
        },

        checkReferral() {
            // CASE - HeyDominik
            if (this.currentUser.referralBy == 664) {
                this.multiplier = 2;
                this.hasMultiplier = true;
                this.referral = "HeyDominik";
            }

            // CASE - Majed Photos
            if (this.currentUser.referralBy == 31847) {
                this.basicPlans.six = 210;
                this.basicPlans.twelve = 310;
                this.referral = "MajedPhotos";
            }

            // CASE - Valentin Dimitrov
            if (this.currentUser.referralBy == 23425) {
                this.basicPlans.six = 220;
                this.basicPlans.twelve = 320;
                this.referral = "ValentinDimitrov";
            }

            // CASE - Jord Hammond
            if (this.currentUser.referralBy == 27331) {
                this.basicPlans.one = 130;
                this.basicPlans.six = 230;
                this.basicPlans.twelve = 330;
                this.referral = "JordHammond";
            }

            // CASE - MonicaJ aka Flawfullyyours
            if (this.currentUser.referralBy == 25620) {
                this.basicPlans.one = 140;
                this.basicPlans.six = 240;
                this.basicPlans.twelve = 340;
                this.referral = "MonicaJ";
            }

            // CASE - JavierSomoza
            if (this.currentUser.referralBy == 75283) {
                this.basicPlans.one = 150;
                this.basicPlans.six = 250;
                this.basicPlans.twelve = 350;
                this.referral = "JavierSomoza";
            }

            // CASE - Shauna
            if (this.currentUser.referralBy == 50604) {
                this.basicPlans.one = 160;
                this.basicPlans.six = 260;
                this.basicPlans.twelve = 360;
                this.referral = "sharnz";
            }

            // CASE - Shauna
            if (this.currentUser.referralBy == 10278) {
                this.basicPlans.one = 170;
                this.basicPlans.six = 270;
                this.basicPlans.twelve = 370;
                this.referral = "benleavitt";
            }
        },

        handleBaseSubscriptionCounter(amount) {
            var total;
            total = this.baseSubscriptionCampaignCount + amount;
            if (total < 4 && total > 0) {
                this.baseSubscriptionCampaignCount = total;
            }
        },
    },

    mounted() {
        // Get all the price plans
        this.getPricePlans();

        // Check to see if user is referred to by someone
        this.checkReferral();

        // FIXME - Run check
        this.checkIs2021();

        // Handle breadcrumbs
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Subscribe", route: "subscribe" }]);
    },

    computed: {
        ...mapGetters({ currentUser: "auth/currentUser" }),
        enterpriseOne() {
            var prefix = "101";
            return this.getEnterpriseDetails(prefix);
        },

        enterpriseSix() {
            var prefix = "102";
            return this.getEnterpriseDetails(prefix);
        },

        enterpriseTwelve() {
            var prefix = "103";
            return this.getEnterpriseDetails(prefix);
        },
    },
};
</script>
